import { transformNumField } from '../../../utils';
export default {
    name: 'NumRender',
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: '',
        },
    },
    computed: {
        formattedValue() {
            return transformNumField(this.value);
        },
    },
};
